<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>
               
        <!-- Lien de paiement -->
        <section id="content-8" class="wide-60 content-section division sct_tuto  grey_bck_section">
            <div class="container">	


                <!-- SECTION TITLE 	-->	
                <div class="row">	
                    <div class="col-lg-10 offset-lg-1 section-title">	

                        <!-- Title 	-->	
                        <h2 class="h2-lg">Le lien de paiement <br>APAYM Pro</h2>	

                        <!-- Text -->
                        <p></p>
                                
                    </div>	
                </div> 	 <!-- END SECTION TITLE -->	


                <div class="row">
                    <div class="col-md-12">
                    


                        <!-- TABS CONTENT -->
                        <div class="tab-content" id="pills-tabContent">


                            <!-- TAB-1 CONTENT -->
                            <div class="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="tab1-list">
                                <div class="row d-flex align-items-center">


                                    <!-- TAB-1 TEXT -->
                                    <div class="col-md-6">
                                        <div class="content-txt ind-45"> 
                                            
                                            <p>Le lien de paiement est un lien URL sécurisé à usage unique dont dispose un marchand APAYM PRO.</p>
                                            <p><a href="https://pay.apaym.com/weblogyoffshore" target="_blank" class="link">https://pay.apaym.com/weblogyoffshore</a> </p>

                                            <p>Grâce à ce lien, encaisser instantanément vos clients à distance et partout dans le monde entier.</p>

                                            <p>Le marchand APAYM PRO peut partager son lien de paiement à tous les clients par différents canaux de communication :</p>

                    
                                                
                                            <!-- Text -->	
                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Par SMS</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Par WhatsApp</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Par adresse email</p>							
                                            </div>

                                            <div class="box-list m-top-15 animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="600">					
                                                <div class="box-list-icon"><svg class="svg-inline--fa fa-genderless fa-w-9 orange" aria-hidden="true" data-prefix="fas" data-icon="genderless" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 512" data-fa-i2svg=""><path fill="currentColor" d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"></path></svg><!-- <i class="fas fa-genderless"></i> --></div>
                                                <p>Sur les réseaux sociaux</p>							
                                            </div>

                                            <!-- Text -->	
                                            <p class="">
                                            <!-- Button -->						
                                            <a href="https://apaym.com/pro/souscription" target="_blank" class="btn btn-lightorange">Créer un compte Pro</a>                    
                                            </p>

                                            </div>	
                                            

                                    </div>	<!-- END TAB-1 TEXT -->


                                    <!-- TAB-1 IMAGE -->
                                    <div class="col-md-6">
                                        <div class="content-img animated fadeInLeft visible" data-animation="fadeInLeft" data-animation-delay="400">
                                            <img class="img-fluid" src="@/assets/images/lien-paiement.png" width="500" alt="content-image">
                                        </div>
                                    </div>

                                    
                                </div>
                            </div>	<!-- END TAB-1 CONTENT -->

                        </div>	<!-- END TABS CONTENT -->


                    </div>	
                </div>     <!-- End row -->	
            </div>     <!-- End container -->	
        </section>
        <!-- Lien de paiement-->

      

       

        <footer_menu></footer_menu>
    </div>

</template>

<script>
import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
export default{
    name :'nos_cartes',
    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu
    } 
}


</script>

<style scoped>
.pro_part{
    background: url(@/assets/images/pic-pro-interne.png) no-repeat;   
}
.sct_bck{
    background: url(@/assets/images/95b26da8.png) no-repeat;   
}
.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}
#download-2 .bg-inner {
    /* background-image: url(../images/download-2.jpg); */
    position: relative;
    z-index: 1;
    background: #261b64;
}
.orange{
color: #ff9e00;
}
.h5-sm{
    color: #261b64;
}

</style>

